import axios from "../axios";

const getCompanyEmail = () => {
  const promise = new Promise((resolve, reject) => {
    const url = `keynote/companyemail`;
    axios
      .get(url)
      .then((res) => resolve(res.data))
      .catch((res) => {
        reject(res);
      });
  });

  return promise;
};

const sendCompanyEmail = (keynote_id_list) => {
  const promise = new Promise((resolve, reject) => {
    const url = `keynote/companyemail`;
    axios
      .post(url, { keynote_id_list })
      .then((res) => resolve(res.data))
      .catch((res) => {
        reject(res);
      });
  });

  return promise;
};

export default {
  getCompanyEmail,
  sendCompanyEmail,
};
